import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const REGISTRY_SUMMARY_QUERY = gql`
  query RegistrySummaryQuery($registryId: StrictString!) @skipAudit @engComponent(name: REGISTRY) {
    registry(id: $registryId) {
      ... on RegistryNode {
        ...RegistrySummaryGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('RegistrySummary').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
